import React from 'react';

import { Heading, SanityImage } from '../elements';

const TeamCard = ({ data }) => {
  return (
    <div className="column is-4">
      <div className="card is-borderless h-full">
        <div className="card-image">
          <figure className="image">
            {data.avatar && data.avatar.asset && (
              <SanityImage
                alt={data.avatar.alt || 'Capextax'}
                fluid={data.avatar.asset.id}
                width={200}
              />
            )}
          </figure>
        </div>
        <div className="card-content">
          <div className="media">
            <div className="media-content">
              <Heading dark className="title is-4">
                {data.name}
              </Heading>
              <p className="subtitle is-5 has-text-orange has-text-weight-bold">
                {data.fewText}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
